import React from "react";

const steps = ["Application recieved", "Test", "Review", "Feedback"];

export const StepperHeader = ({ stage = 0 }) => {
  const completeSvg = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2"
    >
      <path
        d="M39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20Z"
        fill="white"
        stroke="#EEEEEE"
      />
      <path
        d="M28.1719 14L17.1719 25L12.1719 20"
        stroke="#03CEA4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    // {/* progressbar */ }
    <div className="w-100 ml-4 bg-light rounded-pill text-dark d-flex align-items-center position-relative overflow-hidden">
      {/* <div className='w-75 position-absolute successBG' style={{ top: 0, left: 0, bottom: 0 }} /> */}
      {steps.map((item, index) => (
        <div
          className={`d-flex align-items-center py-2 pl-5 ${
            index <= stage && "successBG pr-5"
          }`}
          style={{
            zIndex: 1,
            borderRadius: index < stage ? "0" : "0 50rem 50rem 0",
            marginLeft: -1,
            height: "100%",
          }}
          key={`step-${index}`}
        >
          {stage > index ? (
            completeSvg
          ) : (
            <div
              style={{ width: 40, height: 40 }}
              className={`d-flex align-items-center justify-content-center ${
                index === stage ? `border-light` : `border-dark`
              } rounded-circle border mr-2`}
            >
              <span className="rounded-circle">{index + 1}</span>
            </div>
          )}
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};
